export const schedulerIntegrations = []

/** Supported Integration */
export const schedulerIntegrationSmwClient = {
    id: "smwclient",
    name: "SMW Client",
    tasks: [
        {
            id: "smwclient.customer",
            name: "SMW Customer",
            description: "Customer"
        },
        {
            id: "smwclient.customer.branch",
            name: "SMW Customer Branch",
            description: "Customer Branch"
        },
        {
            id: "smwclient.item",
            name: "SMW Item",
            description: "Item"
        },
        {
            id: "smwclient.delivery.order",
            name: "SMW Delivery Order",
            description: "Delivery Order"
        },
        {
            id: "smwclient.scheduler.log",
            name: "SMW Scheduler Log",
            description: "Scheduler Log"
        },
        {
            id: "smwclient.region.area",
            name: "SMW Region Area",
            description: "Region Area"
        },
        {
            id: "smwclient.region.state",
            name: "SMW Region State",
            description: "Region State"
        },
        {
            id: "smwclient.injectionprop.document",
            name: "SMW Injection Prop",
            description: "Document"
        },
    ]
}

export const schedulerIntegrationAutocount = {
    id: "autocount",
    name: "Autocount Accounting",
    tasks: [
        {
            id: "autocount.debtor",
            name: "AC Debtor",
            description: "Debtor"
        },
        {
            id: "autocount.creditor",
            name: "AC Creditor",
            description: "Creditor"
        },
        {
            id: "autocount.sales.order",
            name: "AC Sales Order",
            description: "Autocount Sales Order"
        },
        {
            id: "autocount.delivery.order",
            name: "AC Delivery Order",
            description: "Autocount Delivery Order"
        },
    ]
}